var _mask, _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDocsFilled(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-outside-1_2456_18844",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36,
    fill: "black"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    width: 36,
    height: 36
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 18C2 9.16344 9.16344 2 18 2C26.8366 2 34 9.16344 34 18C34 26.8366 26.8366 34 18 34C9.16344 34 2 26.8366 2 18Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 18C2 9.16344 9.16344 2 18 2C26.8366 2 34 9.16344 34 18C34 26.8366 26.8366 34 18 34C9.16344 34 2 26.8366 2 18Z",
    fill: "#F6F6F6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 32C10.268 32 4 25.732 4 18H0C0 27.9411 8.05888 36 18 36V32ZM32 18C32 25.732 25.732 32 18 32V36C27.9411 36 36 27.9411 36 18H32ZM18 4C25.732 4 32 10.268 32 18H36C36 8.05888 27.9411 0 18 0V4ZM18 0C8.05888 0 0 8.05888 0 18H4C4 10.268 10.268 4 18 4V0Z",
    fill: "white",
    mask: "url(#path-1-outside-1_2456_18844)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.52 11.333H15.48C12.96 11.333 12.3333 12.0063 12.3333 14.693V22.1997C12.3333 23.973 13.3067 24.393 14.4867 23.1263L14.4933 23.1197C15.04 22.5397 15.8733 22.5863 16.3467 23.2197L17.02 24.1197C17.56 24.833 18.4333 24.833 18.9733 24.1197L19.6467 23.2197C20.1267 22.5797 20.96 22.533 21.5067 23.1197C22.6933 24.3863 23.66 23.9663 23.66 22.193V14.693C23.6667 12.0063 23.04 11.333 20.52 11.333ZM20 17.833H16C15.7267 17.833 15.5 17.6063 15.5 17.333C15.5 17.0597 15.7267 16.833 16 16.833H20C20.2733 16.833 20.5 17.0597 20.5 17.333C20.5 17.6063 20.2733 17.833 20 17.833ZM20.6667 15.1663H15.3333C15.06 15.1663 14.8333 14.9397 14.8333 14.6663C14.8333 14.393 15.06 14.1663 15.3333 14.1663H20.6667C20.94 14.1663 21.1667 14.393 21.1667 14.6663C21.1667 14.9397 20.94 15.1663 20.6667 15.1663Z",
    fill: "#667085"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocsFilled);
export default __webpack_public_path__ + "static/media/docs-filled.a658cb1a2e8ff392a41cf5d213e91ff4.svg";
export { ForwardRef as ReactComponent };